const service = (() => {
  // Generate cryptographically strong random string
  // https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
  const generateKey = () => {
    let random = new Uint32Array(1);
    let cryptoObj = window.crypto || window.msCrypto;
    cryptoObj.getRandomValues(random);
    return +new Date() + "_" + random[0];
  };

  return { generateKey };
})();

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/security.js